import { appendHelpText, createControlLabel, createFieldScaffold } from "../shared.ts";
import type { RenderContext, RenderField } from "../types.ts";

export const renderSelectField = (
  field: RenderField<"SELECT">,
  context: RenderContext,
): HTMLElement => {
  const scaffold = createFieldScaffold(field, context);
  const label = createControlLabel(field.label, field.required, scaffold.inputId);

  const select = document.createElement("select");
  select.className = "fb-control fb-select";
  select.id = scaffold.inputId;
  select.name = field.key;
  select.required = field.required;

  const placeholder = document.createElement("option");
  placeholder.value = "";
  placeholder.textContent = field.placeholder || "Select an option";
  placeholder.disabled = field.required;
  placeholder.selected = true;
  select.append(placeholder);

  for (const option of field.configJson.options) {
    const element = document.createElement("option");
    element.value = option.value;
    element.textContent = option.label;
    select.append(element);
  }

  if (scaffold.helpId) {
    select.setAttribute("aria-describedby", scaffold.helpId);
  }

  scaffold.wrapper.append(label, select);
  appendHelpText(scaffold, field);

  return scaffold.wrapper;
};
